// @flow strict

import React from 'react';
import PropTypes from 'prop-types';
import { ProductItem } from './productItem.js';

import * as styles from './menuProducts.module.less';

export const MenuProducts = ({ data }) => {
  return (
    <div className={styles.itemsWrapper}>
      <div className={styles.itemsCol}>
        {data.items.map((productItem, index) => {
          if (index % 2 !== 0) {
            return;
          }
          return <ProductItem key={productItem.name} data={productItem} />;
        })}
      </div>
      <div className={styles.itemsCol}>
        {data.items.map((productItem, index) => {
          if (index % 2 !== 1) {
            return;
          }
          return <ProductItem key={productItem.name} data={productItem} />;
        })}
      </div>
      <div className={styles.secondaryArea + ' ' + styles.lastCol}>
        <img
            className={styles.teamImage}
            src={data.teamImage.src.publicURL}
            alt={data.teamImage.alt}
        />
        <div className={styles.ctaParagraph}>
            <span>{data.ctaParagraph.headline}</span>
            <p>{data.ctaParagraph.text}</p>
        </div>
        <a href={data.ctaButton.href} className={styles.ctaButton}>
            {data.ctaButton.text}
            <svg
                width="10"
                height="16"
                viewBox="0 0 10 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.21127 14.7891L1 13.5779L6.57746 8.0004L1 2.42294L2.21127 1.21167L9 8.0004L2.21127 14.7891Z"
                    stroke-width="0.5"
                    stroke-linejoin="round"
                />
            </svg>
        </a>
        <ul className={styles.benefits}>
            {data.benefits?.map(text =>
                <li>
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.10938 10.9997L9.5316 14.6663L15.8872 7.33301" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>
                    {text}
                  </span>
                </li>
            )}
        </ul>
      </div>
    </div>
  );
};

MenuProducts.propTypes = {
    data: PropTypes.object,
};
